"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeFiveServiceSectionGeneratedProps = {
    /** Default: "OUR SERVICES" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Comprehensive ENT Care With Advanced Diagnostic" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "icon" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-icon-1.svg" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Ear Infection & Hearing Loss Treatment" */
    sectionDiv0Div1Div0Div0H30H3Text?: ReactNode;
    sectionDiv0Div1Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div1Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "#" */
    sectionDiv0Div1Div0Div0Link0LinkHref?: string;
    sectionDiv0Div1Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div1Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Expert diagnosis and treatment related conditions, including hearing loss" */
    sectionDiv0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "service" */
    sectionDiv0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/service-img-7.jpg" */
    sectionDiv0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-icon-2.svg" */
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Sinus & Nasal Allergy Management" */
    sectionDiv0Div1Div1Div0H30H3Text?: ReactNode;
    sectionDiv0Div1Div1Div0H30H3Visible?: boolean;
    sectionDiv0Div1Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "#" */
    sectionDiv0Div1Div1Div0Link0LinkHref?: string;
    sectionDiv0Div1Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div1Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Providing comprehensive chronic sinusitisand breathing difficulties." */
    sectionDiv0Div1Div1Div0P0PText?: ReactNode;
    /** Default: "service" */
    sectionDiv0Div1Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/service-img-8.jpg" */
    sectionDiv0Div1Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-icon-3.svg" */
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Voice & Throat Infection Treatment" */
    sectionDiv0Div1Div2Div0H30H3Text?: ReactNode;
    sectionDiv0Div1Div2Div0H30H3Visible?: boolean;
    sectionDiv0Div1Div2Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "#" */
    sectionDiv0Div1Div2Div0Link0LinkHref?: string;
    sectionDiv0Div1Div2Div0Link0LinkVisible?: boolean;
    sectionDiv0Div1Div2Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Specialized treatment for vocal cord issues & swallowing disorders." */
    sectionDiv0Div1Div2Div0P0PText?: ReactNode;
    /** Default: "service" */
    sectionDiv0Div1Div2ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/service-img-9.jpg" */
    sectionDiv0Div1Div2ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div2ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div2ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-icon-4.svg" */
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Endoscopic Sinus Surgery & Treatment" */
    sectionDiv0Div1Div3Div0H30H3Text?: ReactNode;
    sectionDiv0Div1Div3Div0H30H3Visible?: boolean;
    sectionDiv0Div1Div3Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "#" */
    sectionDiv0Div1Div3Div0Link0LinkHref?: string;
    sectionDiv0Div1Div3Div0Link0LinkVisible?: boolean;
    sectionDiv0Div1Div3Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Minimally invasive surgical for chronic sinus conditions & nasal obstructions." */
    sectionDiv0Div1Div3Div0P0PText?: ReactNode;
    /** Default: "service" */
    sectionDiv0Div1Div3ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/service-img-10.jpg" */
    sectionDiv0Div1Div3ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div3ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div3ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeFiveServiceSectionGenerated: FC<HomeFiveServiceSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "OUR SERVICES",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Comprehensive ENT Care With Advanced Diagnostic",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-icon-1.svg",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0H30H3Text = "Ear Infection & Hearing Loss Treatment",
    sectionDiv0Div1Div0Div0H30H3Visible,
    sectionDiv0Div1Div0Div0H30H3Renderer,
    sectionDiv0Div1Div0Div0H30H3Props,
    sectionDiv0Div1Div0Div0Link0LinkHref = "#",
    sectionDiv0Div1Div0Div0Link0LinkVisible,
    sectionDiv0Div1Div0Div0Link0LinkRenderer,
    sectionDiv0Div1Div0Div0Link0LinkProps,
    sectionDiv0Div1Div0Div0P0PText = "Expert diagnosis and treatment related conditions, including hearing loss",
    sectionDiv0Div1Div0ImageWithBasePath0ImageAlt = "service",
    sectionDiv0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/service-img-7.jpg",
    sectionDiv0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-icon-2.svg",
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0H30H3Text = "Sinus & Nasal Allergy Management",
    sectionDiv0Div1Div1Div0H30H3Visible,
    sectionDiv0Div1Div1Div0H30H3Renderer,
    sectionDiv0Div1Div1Div0H30H3Props,
    sectionDiv0Div1Div1Div0Link0LinkHref = "#",
    sectionDiv0Div1Div1Div0Link0LinkVisible,
    sectionDiv0Div1Div1Div0Link0LinkRenderer,
    sectionDiv0Div1Div1Div0Link0LinkProps,
    sectionDiv0Div1Div1Div0P0PText = "Providing comprehensive chronic sinusitisand breathing difficulties.",
    sectionDiv0Div1Div1ImageWithBasePath0ImageAlt = "service",
    sectionDiv0Div1Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/service-img-8.jpg",
    sectionDiv0Div1Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-icon-3.svg",
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div2Div0H30H3Text = "Voice & Throat Infection Treatment",
    sectionDiv0Div1Div2Div0H30H3Visible,
    sectionDiv0Div1Div2Div0H30H3Renderer,
    sectionDiv0Div1Div2Div0H30H3Props,
    sectionDiv0Div1Div2Div0Link0LinkHref = "#",
    sectionDiv0Div1Div2Div0Link0LinkVisible,
    sectionDiv0Div1Div2Div0Link0LinkRenderer,
    sectionDiv0Div1Div2Div0Link0LinkProps,
    sectionDiv0Div1Div2Div0P0PText = "Specialized treatment for vocal cord issues & swallowing disorders.",
    sectionDiv0Div1Div2ImageWithBasePath0ImageAlt = "service",
    sectionDiv0Div1Div2ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/service-img-9.jpg",
    sectionDiv0Div1Div2ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div2ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div2ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-icon-4.svg",
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div3Div0H30H3Text = "Endoscopic Sinus Surgery & Treatment",
    sectionDiv0Div1Div3Div0H30H3Visible,
    sectionDiv0Div1Div3Div0H30H3Renderer,
    sectionDiv0Div1Div3Div0H30H3Props,
    sectionDiv0Div1Div3Div0Link0LinkHref = "#",
    sectionDiv0Div1Div3Div0Link0LinkVisible,
    sectionDiv0Div1Div3Div0Link0LinkRenderer,
    sectionDiv0Div1Div3Div0Link0LinkProps,
    sectionDiv0Div1Div3Div0P0PText = "Minimally invasive surgical for chronic sinus conditions & nasal obstructions.",
    sectionDiv0Div1Div3ImageWithBasePath0ImageAlt = "service",
    sectionDiv0Div1Div3ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/service-img-10.jpg",
    sectionDiv0Div1Div3ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div3ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div3ImageWithBasePath0ImageProps,
}) => {
    return (
        <section className="services-section-five section">
            <div className="container-fluid">
                <div className="section-header section-header-five text-center">
                    <div className="section-sub-title">
                        {" "}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {" "}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className="services-details">
                    <div className="services-item-five one">
                        <div className="services-content">
                            <div className="services-icon">
                                {renderNode(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div1Div0Div0H30H3Visible, sectionDiv0Div1Div0Div0H30H3Renderer, (
                                <h3 className="custom-title" {...(sectionDiv0Div1Div0Div0H30H3Props ?? {})}>{sectionDiv0Div1Div0Div0H30H3Text}</h3>
                            ))}
                            <p className="description">{sectionDiv0Div1Div0Div0P0PText}</p>
                            {renderNode(sectionDiv0Div1Div0Div0Link0LinkVisible, sectionDiv0Div1Div0Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div1Div0Div0Link0LinkHref} className="more-link link-one" {...(sectionDiv0Div1Div0Div0Link0LinkProps ?? {})}>
                                    <i className="isax isax-arrow-right-1" />
                                </SmartLink>
                            ))}
                        </div>
                        {renderNode(sectionDiv0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid large-img one-img" {...(sectionDiv0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="services-item-five two">
                        <div className="services-content">
                            <div className="services-icon">
                                {renderNode(sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div1Div1Div0H30H3Visible, sectionDiv0Div1Div1Div0H30H3Renderer, (
                                <h3 className="custom-title" {...(sectionDiv0Div1Div1Div0H30H3Props ?? {})}>{sectionDiv0Div1Div1Div0H30H3Text}</h3>
                            ))}
                            <p className="description">{sectionDiv0Div1Div1Div0P0PText}</p>
                            {renderNode(sectionDiv0Div1Div1Div0Link0LinkVisible, sectionDiv0Div1Div1Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div1Div1Div0Link0LinkHref} className="more-link link-two" {...(sectionDiv0Div1Div1Div0Link0LinkProps ?? {})}>
                                    <i className="isax isax-arrow-right-1" />
                                </SmartLink>
                            ))}
                        </div>
                        {renderNode(sectionDiv0Div1Div1ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div1Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1ImageWithBasePath0ImageAlt} className="img-fluid large-img two-img" {...(sectionDiv0Div1Div1ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="services-item-five three">
                        <div className="services-content">
                            <div className="services-icon">
                                {renderNode(sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div1Div2Div0H30H3Visible, sectionDiv0Div1Div2Div0H30H3Renderer, (
                                <h3 className="custom-title" {...(sectionDiv0Div1Div2Div0H30H3Props ?? {})}>{sectionDiv0Div1Div2Div0H30H3Text}</h3>
                            ))}
                            <p className="description">{sectionDiv0Div1Div2Div0P0PText}</p>
                            {renderNode(sectionDiv0Div1Div2Div0Link0LinkVisible, sectionDiv0Div1Div2Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div1Div2Div0Link0LinkHref} className="more-link link-three" {...(sectionDiv0Div1Div2Div0Link0LinkProps ?? {})}>
                                    <i className="isax isax-arrow-right-1" />
                                </SmartLink>
                            ))}
                        </div>
                        {renderNode(sectionDiv0Div1Div2ImageWithBasePath0ImageVisible, sectionDiv0Div1Div2ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div1Div2ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div2ImageWithBasePath0ImageAlt} className="img-fluid large-img three-img" {...(sectionDiv0Div1Div2ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="services-item-five four">
                        <div className="services-content">
                            <div className="services-icon">
                                {renderNode(sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div1Div3Div0H30H3Visible, sectionDiv0Div1Div3Div0H30H3Renderer, (
                                <h3 className="custom-title" {...(sectionDiv0Div1Div3Div0H30H3Props ?? {})}>{sectionDiv0Div1Div3Div0H30H3Text}</h3>
                            ))}
                            <p className="description">{sectionDiv0Div1Div3Div0P0PText}</p>
                            {renderNode(sectionDiv0Div1Div3Div0Link0LinkVisible, sectionDiv0Div1Div3Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div1Div3Div0Link0LinkHref} className="more-link link-four" {...(sectionDiv0Div1Div3Div0Link0LinkProps ?? {})}>
                                    <i className="isax isax-arrow-right-1" />
                                </SmartLink>
                            ))}
                        </div>
                        {renderNode(sectionDiv0Div1Div3ImageWithBasePath0ImageVisible, sectionDiv0Div1Div3ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div1Div3ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div3ImageWithBasePath0ImageAlt} className="img-fluid large-img four-img" {...(sectionDiv0Div1Div3ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFiveServiceSectionGenerated;
